"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = void 0;
var react_1 = __importDefault(require("react"));
var InlineIcon_1 = require("./InlineIcon");
var Label_1 = require("./Label");
var InputAddon = function (_a) {
    var icon = _a.icon;
    return (react_1.default.createElement("div", { className: "flex flex-col border border-grey border-r-0 rounded rounded-tr-none\nrounded-br-none bg-grey-light px-2 justify-center" },
        react_1.default.createElement(InlineIcon_1.InlineIcon, { name: icon })));
};
exports.Input = react_1.default.forwardRef(function (_a, ref) {
    var placeholder = _a.placeholder, name = _a.name, value = _a.value, autofocus = _a.autofocus, _b = _a.type, type = _b === void 0 ? "text" : _b, icon = _a.icon, _c = _a.size, size = _c === void 0 ? "lg" : _c, propsClassName = _a.className, readOnly = _a.readOnly, onChange = _a.onChange, onClick = _a.onClick, onBlur = _a.onBlur, onFocus = _a.onFocus, onKeyDown = _a.onKeyDown, label = _a.label;
    var commonClassName = "border border-grey leading-normal text-grey-darkest focus:border-blue";
    var className = size === "lg"
        ? "".concat(commonClassName, " px-2 py-1 shadow-inner")
        : commonClassName;
    var classes = [className, propsClassName];
    var input = (react_1.default.createElement("div", { className: "relative flex w-full" },
        icon && react_1.default.createElement(InputAddon, { icon: icon }),
        react_1.default.createElement("input", { name: name, className: classes.join(" "), placeholder: placeholder, value: value, type: type, autoFocus: autofocus, readOnly: readOnly, ref: ref, onChange: onChange, onClick: onClick, onBlur: onBlur, onFocus: onFocus, onKeyDown: onKeyDown, style: { minWidth: 0 } })));
    return label ? react_1.default.createElement(Label_1.Label, { text: label }, input) : input;
});
